// @flow

import * as React from 'react';

import clsx from 'clsx';

import styles from './PlaceholderListContainer.scss';

type Props = {
  children: React.Node,
  className?: string,
};

export function PlaceholderListContainer({
  children,
  className,
}: Props): React.MixedElement {
  return <ul className={clsx(styles.root, className)}>{children}</ul>;
}
